import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initUXTracking } from "./lib/uxTracking";

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
initUXTracking().catch(() => {});
